import script from "./auth-email-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth-email-form.vue?vue&type=script&lang=ts&setup=true"

import "./auth-email-form.vue?vue&type=style&index=0&id=1116c251&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1116c251"]])

export default __exports__